
``;
import { Component, Vue, Prop } from "vue-property-decorator";
import ModalHeader from "@/components/modal-header.vue";
import Job, { ExamJobItem } from "@/lib/job/job";
import { CompanyConfig } from "@/lib/common/acm";
import html2canvas from "html2canvas";
import QrCodeDiy from "./QrCodeDiy.vue";
import request from "@/lib/request/request";
import gateway from "@/lib/request/gateway";

class CodeText {
  mainText = "欢迎使用AI面试"; //主标题
  subText = "快速 · 轻松 · 便捷"; //副标题
  tagShow = false;
  tagText = ""; //标签文字
  mainColor = "#525fff";
  subColor = "#181f71";
  logoShow = false;
  logoUrl = ""; //公司logo图片
  coderImgUrl = ""; //考试链接url
}

// 面试链接
@Component({
  components: {
    ModalHeader,
    QrCodeDiy
  }
})
export default class ExamLink extends Vue {
  @Prop({ type: String, default: "面试二维码" }) title!: string;
  @Prop({ type: String, default: "" }) link!: string;
  @Prop({ type: String, default: "" }) scanStr!: string;
  @Prop({ type: Number, default: 0 }) jobId!: number;
  @Prop({ type: String, default: "" }) jobConcentCode!: string;
  @Prop({ type: String, default: "" }) connectCode!: string;
  @Prop({ type: Number, default: 0 }) examId!: number;
  @Prop({ type: String, default: "" }) examName!: string;
  @Prop({ default: false }) fromJob!: boolean; //职位组点开
  @Prop({ default: {} }) exam!: any; //面试model

  changeColor(e: any) {
    if (!e) {
      // this.CodeText[key] = def;
    }
  }

  fromJobFlag = this.fromJob;
  jobIdFlag = this.jobId; //组id 存取用
  jobConcentCodeFlag = this.jobConcentCode; //组链接码 生产二维码用
  name = "modal-exam-link";
  tab = 1;
  examJobList: ExamJobItem[] = [];
  showOneJob = false; //展示某一职位组二维码
  // currentJob = new ExamJobItem();
  hasJobs = false; //是否有职位组
  show = false;
  hoverJob = new CodeText();
  CodeText = new CodeText();
  editing = false;
  imgFile: any = null;
  submiting = false;

  clikTab(i: number) {
    if (this.editing) return;
    this.tab = i;
    this.fromJobFlag = i === 1 ? false : true;
    if (i === 1) {
      this.getCodeText();
    }
    if (i === 2) {
      this.showOneJob = false;
    }
  }
  ss = false;
  setHoverJob(it: any) {
    this.ss = true;
    this.$nextTick(() => {
      this.fromJobFlag = true;
      this.jobConcentCodeFlag = it.connectCode;
      this.jobIdFlag = it.jobId;
      this.getCodeText(it.jobId);
    });
  }

  async saveCodeText() {
    console.log(this.CodeText);
    //处理空
    if (!this.CodeText.mainText) {
      this.$message.warning("请输入主标题");
      return;
    }
    if (!this.CodeText.subText) {
      this.$message.warning("请输入副标题");
      return;
    }
    if (!this.CodeText.mainColor) {
      this.$message.warning("请选择主题色");
      return;
    }
    if (!this.CodeText.subColor) {
      this.$message.warning("请选择辅助色");
      return;
    }
    if (this.CodeText.tagShow && !this.CodeText.tagText) {
      this.$message.warning("请输入标签文字");
      return;
    }
    if (this.CodeText.logoShow && !this.CodeText.logoUrl) {
      this.$message.warning("请上传logo");
      return;
    }

    this.submiting = true;
    if (!this.CodeText.logoShow) {
      this.CodeText.logoUrl = "";
    } else {
      if (this.imgFile) {
        // 上传图片到oss
        await gateway
          .anonymousGetPostPolicy(this.imgFile.name)
          .then(async (postRes: any) => {
            if (postRes) {
              const tempUrl =
                postRes.cdn + "/" + encodeURIComponent(postRes.dir);
              await gateway
                .upload(postRes, this.imgFile)
                .then((res: any) => {
                  console.log("upload res : ", res);
                })
                .finally(() => {
                  this.CodeText.logoUrl = tempUrl;
                });
            }
          })
          .catch((err: any) => {
            this.$message.error(err.msg);
            this.submiting = false;
            return;
          });
      }
    }

    await request
      .post(
        "/aiExam/" + (this.fromJobFlag ? "job" : "exam") + "/qrConfigSave",
        this.fromJobFlag
          ? { jobId: this.jobIdFlag, qrConfig: this.CodeText }
          : {
              examId: this.examId,
              qrConfig: this.CodeText
            }
      )
      .then(() => {
        this.$message.success("保存成功");
        this.submiting = false;
        this.cancelEdit();
      })
      .catch((err: any) => {
        this.$message.error(err.msg);
        this.submiting = false;
      });
  }
  // 带id hover时获取二维码
  async getCodeText(id?: number) {
    await request
      .post(
        "/aiExam/" + (this.fromJobFlag ? "job" : "exam") + "/qrConfigGet",
        this.fromJobFlag
          ? { jobId: id || this.jobIdFlag }
          : {
              examId: id || this.examId
            }
      )
      .then((resp: any) => {
        if (resp?.data?.data?.find) {
          if (id) {
            this.hoverJob = resp.data.data.qrConfig;
            return;
          }
          this.CodeText = resp.data.data.qrConfig;
          console.log(this.CodeText);
        } else {
          if (id) {
            this.hoverJob = new CodeText();
            return;
          }
          this.CodeText = new CodeText();
        }
      })
      .finally(() => {
        const url =
          process.env.VUE_APP_AI_INTERVIEW_HOST +
          "/code?c=" +
          (this.fromJobFlag ? this.jobConcentCodeFlag : this.connectCode);
        if (id) {
          // this.hoverJob.coderImgUrl = this.hoverJob.coderImgUrl || url;
          this.hoverJob.coderImgUrl = url;
          try {
            setTimeout(() => {
              // const aa = this.$refs["job-pop" + id]?.[0];
              (this.$refs["job-pop" + id]?.[0] as any)?.getQrServe();
            }, 10);
          } catch (e) {
            console.log(e);
          }
        } else {
          // this.CodeText.coderImgUrl = this.CodeText.coderImgUrl || url;
          this.CodeText.coderImgUrl = url;
        }
      });
  }

  edit() {
    this.editing = true;
  }
  cancelEdit() {
    this.imgFile = null;
    this.getCodeText().then(() => {
      this.editing = false;
    });
  }
  openFile(e: any) {
    const file = e?.target?.files?.[0];
    console.log(file);
    if (!file) {
      this.$message.warning("请选择图片");
      return;
    }
    if (!file.type.includes("image")) {
      this.$message.warning("请选择常用的图片格式");
      return;
    }
    if (file.size > 1024 * 1024 * 2) {
      this.$message.warning("图片大小不能超过2M");
      return;
    }

    this.imgFile = file;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.CodeText.logoUrl = reader.result as string;
    };
  }

  //是否纯web端
  get onlyWeb() {
    return this?.exam?.platformVersion === 1;
  }

  get isInvite() {
    return this?.exam?.isNoCreateOpenJoin === 1;
  }

  async created() {
    if (!this.fromJobFlag) {
      await this.getExamJobList();
    }
    await this.getCodeText();
    this.show = true;
  }
  async getExamJobList() {
    if (!this.examId) return;
    await Job.getExamJobList({ examId: this.examId }).then(
      (res: ExamJobItem[]) => {
        this.examJobList = res.filter(res => res.type === "job");
        this.hasJobs = this.examJobList.length ? true : false;
      }
    );
  }
  //公司二维码用logo
  get mpLogo() {
    return CompanyConfig.getInstance().mpLogo;
  }
  selectOneJob(it: ExamJobItem) {
    this.fromJobFlag = true;
    this.jobConcentCodeFlag = it.connectCode;
    this.jobIdFlag = it.jobId;
    this.getCodeText();
    this.showOneJob = true;
  }
  close() {
    this.$emit("on-add-cancel");
  }

  copyLink() {
    //创建input标签
    const input = document.createElement("input");
    //将input的值设置为需要复制的内容
    input.value = this.link;
    //添加input标签
    document.body.appendChild(input);
    //选中input标签
    input.select();
    //执行复制
    document.execCommand("copy");
    //移除input标签
    document.body.removeChild(input);
    this.$message.success("复制成功");
  }
  copyLinkJob(url: string) {
    //创建input标签
    const input = document.createElement("input");
    //将input的值设置为需要复制的内容
    input.value = url;
    //添加input标签
    document.body.appendChild(input);
    //选中input标签
    input.select();
    //执行复制
    document.execCommand("copy");
    //移除input标签
    document.body.removeChild(input);
    this.$message.success("复制成功");
  }

  downloadBarcode(fileName = "AI面试二维码", coderAnchor = "coderAnchor") {
    this.$message.success("二维码下载中");
    const anchor = this.$refs[coderAnchor] as HTMLElement;
    // 复制一个anchor元素加入到document
    const copyAnchor = anchor.cloneNode(true) as HTMLElement;
    copyAnchor.style.position = "fixed";
    copyAnchor.style.top = "-10000px";
    copyAnchor.style.left = "-10000px";
    document.body.appendChild(copyAnchor);
    html2canvas(copyAnchor, {
      useCORS: true,
      allowTaint: true,
      scale: 3,
      scrollX: 0,
      scrollY: 0
    }).then((canvas: HTMLCanvasElement) => {
      const dataURL = canvas.toDataURL("image/jpeg");
      const a = document.getElementById("download") as HTMLAnchorElement;
      a.href = dataURL;
      a.download = fileName + ".jpeg";
      a.click();
      // 将copyAnchor移除
      document.body.removeChild(copyAnchor);
    });
  }
}
